import { languageOptions } from '@src/assets/language';
import { languageStorageKey } from '@src/utils/keys';

export const isSupportedLanguage = (language) =>
  Object.values(languageOptions).includes(language);

export const getCurrentLanguage = () => {
  const storedLanguage = window.localStorage.getItem(languageStorageKey);
  if (storedLanguage == null) return languageOptions.turkey;

  let language;
  try {
    language = JSON.parse(storedLanguage);
  } catch (error) {
    console.warn('Invalid stored application language; using Turkish.', error);
    return languageOptions.turkey;
  }

  if (!isSupportedLanguage(language)) {
    console.warn('Unsupported stored application language; using Turkish.');
    return languageOptions.turkey;
  }

  return language;
};
